let value = {
  environment: process.env.REACT_APP_ENV,
}

export default function useDataTransform(props, data) {
  return value
}
